import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import UploadPage from "./pages/UploadPage";
import WorkspacePage from "./pages/WorkspacePage";
import ComparePage from "./pages/ComparePage";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<UploadPage />} />
                    <Route path="/workspace/:id" element={<WorkspacePage />} />
                    <Route path="/compare/:id" element={<ComparePage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}
